export default __webpack_public_path__ + "4b5d4cecd6bf3b72b175c73bbfa9807c.svg";